module.exports = __webpack_public_path__ + "media/images/admin/logo_text_white2-c96a29e4042d8537a14adb53263baf97.png";